import {DataGroup, DataItem, TimelineTimeAxisScaleType} from 'vis-timeline/esnext';
import {DataSet} from 'vis-data/esnext';
import {LOCATIONS} from '@/views/timeline/services/machines/staticdata/locations';
import {MACHINES} from '@/views/timeline/services/machines';
import {ORDERS} from '@/views/timeline/services/machines/staticdata/orders';
import {ObserverType, TimelineDataStoreServiceType} from '@/views/timeline/services/timeline-data-store-service.type';
import {MACHINES_SCALE_SETTINGS} from '@/views/timeline/services/machines/staticdata/scales';
import {ScaleType} from '@/views/timeline/services/scale.type';

class MachineTimelineDataStoreService implements TimelineDataStoreServiceType {

    private locations: DataGroup[] = [];
    private locationsIndex: Map<number | string, DataGroup> = new Map<number | string, DataGroup>();

    private machines: DataGroup[] = [];
    private machinesIndex: Map<number | string, DataGroup> = new Map<number | string, DataGroup>();

    private items: DataSet<DataItem> | null = null;

    private itemIndex: Map<number | string, DataItem> = new Map<number | string, DataItem>();

    private dataObservers: ObserverType[] = [];

    getLocations(): DataGroup[] {
        if (!this.locations || !this.locations.length) {
            this.locations = LOCATIONS;
        }
        return this.locations;
    }

    getLocationsIndex(): Map<number | string, DataGroup> {
        if (!this.locationsIndex || !this.locationsIndex.size) {
            this.getLocations().forEach((location: DataGroup) => {
                if (location.id) {
                    this.locationsIndex.set(location.id, location);
                }
            });
        }
        return this.locationsIndex;
    }

    getMachines(): DataGroup[] {
        if (!this.machines || !this.machines.length) {
            this.machines = MACHINES;
        }
        return this.machines;
    }

    getMachinesIndex(): Map<number | string, DataGroup> {
        if (!this.machinesIndex || !this.machinesIndex.size) {
            this.getMachines().forEach((location: DataGroup) => {
                if (location.id) {
                    this.machinesIndex.set(location.id, location);
                }
            });
        }
        return this.machinesIndex;
    }

    getGroups(): DataSet<DataGroup> {
        return new DataSet<DataGroup>(this.getLocations().concat(this.getMachines()));
    }

    getItems(): DataSet<DataItem> {
        if (!this.items || !this.items.length) {
            this.items = ORDERS;
        }
        return this.items || new DataSet<DataItem>();
    }

    getItemIndex(): Map<number | string, DataItem> {
        if (!this.itemIndex || !this.itemIndex.size) {
            this.getItems().forEach((order: DataItem) => {
                if (order.id) {
                    this.itemIndex.set(order.id, order);
                }
            });
        }
        return this.itemIndex;
    }

    getScaleSettings(): Map<TimelineTimeAxisScaleType, ScaleType> {
        return MACHINES_SCALE_SETTINGS;
    }

    getUniqueStoreKey(): string {
        return 'machinesplanning';
    }

    getHasSimplifiedView(): boolean {
        return false;
    }

    getItemsSimplified(): DataSet<DataItem> {
        return new DataSet<DataItem>();
    }

    getScaleSettingsSimplified(): Map<TimelineTimeAxisScaleType, ScaleType> {
        return new Map();
    }

    registerObserver(observer: ObserverType) {
        this.dataObservers.push(observer);
    }

    private notifyObservers() {
        for (const observer of this.dataObservers) {
            observer.notify();
        }
    }

}

const MACHINE_DATA_STORE_SERVICE_INSTANCE = new MachineTimelineDataStoreService();

export {MACHINE_DATA_STORE_SERVICE_INSTANCE};
